export const listingBookingSettings = {
  section01: {
    title: "Reservas diretas para este anúncio",
  },
  motor: {
    activeTitle: "Motor de reservas ativo",
    inactiveTitle: "Motor de reservas inativo",
    activeDesc: "Os hóspedes podem reservar este anúncio diretamente pelo link.",
    inactiveDesc: "As reservas diretas estão desativadas para este anúncio.",
    statusOn: "Ativo",
    statusOff: "Inativo",
  },
  payment: {
    title: "Quando o hóspede paga?",
    onArrival: {
      name: "Pagar na chegada",
      hint: "Reserve sem custo, pague quando chegar.",
    },
    online: {
      name: "Pagar online",
      hint: "Pague quando a reserva for confirmada.",
    },
  },
  common: {
    saving: "Salvando…",
    onlyOnlineBadge: "Somente pagamento online",
  },
  hold: {
    title: "Tempo de retenção",
    desc: "O calendário fica bloqueado enquanto o hóspede conclui o pagamento.<br>Se ele não pagar dentro do tempo definido, <strong>a disponibilidade é liberada automaticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "hora",
    hours: "horas",
  },
  partial: {
    title: "Pagamento parcial",
    cardTitle: "Permitir pagar apenas parte na reserva",
    descOn: "<strong>Ativado.</strong> O hóspede pode pagar <strong>{percent}%</strong> agora e o restante antes da chegada (ou pagar o valor total).",
    descOff: "<strong>Desativado.</strong> O hóspede paga o <strong>valor total</strong> na reserva.",
    blockTitle: "O restante é pago na acomodação",
    blockOn: "<strong>Ativado.</strong> O hóspede paga <strong>apenas {percent}%</strong> online; o restante é pago <strong>na chegada</strong> (não é possível pagar o valor total online).",
    blockOff: "<strong>Desativado.</strong> O hóspede pode escolher pagar {percent}% ou o valor total online.",
  },
  reminder: {
    title: "Lembrete de saldo",
    cardTitle: "Enviar um lembrete para pagar o saldo pendente",
    daysBefore: "{count} dia antes | {count} dias antes",
    descOn: "<strong>Ativado.</strong> <strong>{daysBefore}</strong> da chegada (por volta das 09:00, horário da propriedade) o hóspede recebe um link para pagar o saldo pendente por <strong>WhatsApp e e-mail</strong>.",
    descOff: "<strong>Desativado.</strong> O hóspede não recebe nenhum lembrete para pagar o saldo online antes da chegada.",
    daysLabel: "Dias antes da chegada",
    hint: "Enviado apenas uma vez e somente para hóspedes com saldo pendente. Se o restante for pago na acomodação, não é enviado.",
  },
  approve: {
    title: "Aprovar reservas",
    cardTitle: "Aprovar cada reserva antes de confirmá-la",
    descOn: "<strong>Ativado.</strong> Cada reserva fica <strong>pendente de sua aprovação</strong>: você recebe uma notificação e decide se aceita ou recusa. Só é confirmada depois que você aprova.",
    descOff: "<strong>Desativado.</strong> As reservas são <strong>confirmadas automaticamente</strong> assim que o pagamento é concluído. Ative se preferir revisar e aprovar cada solicitação você mesmo.",
  },
  toasts: {
    statusUpdatedAll: "Status atualizado em todas as unidades.",
    statusUpdated: "Status atualizado.",
    statusError: "Não foi possível atualizar.",
    paymentUpdated: "Forma de pagamento atualizada.",
    paymentError: "Não foi possível salvar a forma de pagamento.",
    partialUpdated: "Pagamento parcial atualizado.",
    partialError: "Não foi possível salvar o pagamento parcial.",
    reminderUpdated: "Lembrete atualizado.",
    reminderError: "Não foi possível salvar o lembrete.",
    saved: "Salvo.",
    saveError: "Não foi possível salvar.",
    linkCopied: "Link copiado.",
    copyError: "Não foi possível copiar.",
  },
  share: {
    whatsappText: "Olá 👋 Aqui está o link para reservar: {link}",
  },
};
